/**
 * Where links meant for the mobile app point. Read by the native build scripts
 * (the domain the app claims), the server (what a browser on that domain sees)
 * and emails (the links themselves), so the three can't drift apart.
 */

/**
 * The one link domain the app claims (#954). Its links open the app on the
 * same path; choros.app links open the website.
 */
export const DEEP_LINK_HOST = 'deeplink.choros.app'
export const DEEP_LINK_ORIGIN = `https://${DEEP_LINK_HOST}`

/** Where a browser that followed an app link is told to use the app instead */
export const OPEN_IN_APP_PATH = '/open-in-app'

export const APP_STORE_URL =
	'https://apps.apple.com/us/app/choros-real-friends-for-men/id6748773920'
export const GOOGLE_PLAY_URL =
	'https://play.google.com/store/apps/details?id=com.choros.app'
